// Redondeo legal chileno (Doc 06 §4.2). Misma regla que modules/rounding.py.
export const ROUND_MODE_MATH = "MATEMATICO";
export const ROUND_MODE_CUSTOMER = "FAVOR_CLIENTE";
const CASH_CODES = ["EFECTIVO", "CASH", "EFECTIVO_PESOS"];

export const isCashMethod = (m) => CASH_CODES.includes(String(m || "").toUpperCase());

export function roundAmount(total, unidad = 1, modo = ROUND_MODE_MATH) {
  const u = Math.max(1, Number(unidad) || 1);
  const amount = Number(total) || 0;
  const base = Math.floor(amount / u) * u;
  const resto = amount - base;
  if (modo === ROUND_MODE_CUSTOMER) return base;
  return resto * 2 >= u ? base + u : base;
}

/** Devuelve { total_documento, total_pagar, ajuste, aplicado } */
export function resolveRounding(total, paymentMethod, cfg) {
  const doc = Math.round((Number(total) || 0) * 100) / 100;
  if (!cfg?.activo || !isCashMethod(paymentMethod)) {
    return { total_documento: doc, total_pagar: doc, ajuste: 0, aplicado: false };
  }
  const pagar = roundAmount(doc, cfg.unidad, cfg.modo);
  return {
    total_documento: doc,
    total_pagar: pagar,
    ajuste: Math.round((pagar - doc) * 100) / 100,
    aplicado: true,
  };
}
